import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[routeTransformer]',
    standalone: false
})
export class RouteTransformerDirective {
  constructor(private el: ElementRef, private router: Router) {}

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    if (event.target.tagName === 'A') {
      const hrefAtt = event.target.getAttribute('href');
      if (hrefAtt.startsWith('/')) {
        let url;
        let fragment;
        if (hrefAtt.includes('#')) {
          url = hrefAtt.substr(0, hrefAtt.indexOf('#'));
          fragment = hrefAtt.substr(hrefAtt.indexOf('#') + 1);
        } else {
          url = hrefAtt;
        }
        this.router.navigate([url], { fragment });
        event.preventDefault();
      }
    } else {
      return;
    }
  }
}
